import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMapHelpers } from "../../helpers";
import { Body, BodyColor, BodyType, Button, ButtonSize, ButtonTheme, ButtonVariant, Heading, TypographyColor, TypographyType } from "../../ui-elements";
import { RouteConstants } from "../../constants";
import familySkeleton from '../../utils/images/EH Sillhouettes-5-01.svg';
import { IoChevronForwardOutline } from "react-icons/io5";

interface StoryPopupProps {
    story: any;
    handleFocused: (index: number) => void;
    index: number;
}

export const StoryPopup: React.FC<StoryPopupProps> = ({ story, handleFocused, index }) => {
    const navigate = useNavigate();
    const { getCoreSolutions } = useMapHelpers();
    const [searchParams] = useSearchParams();

    const [loaded, setLoaded] = useState(false);

    const handleImageLoad = () => {
        setLoaded(true);
    }

    const handlePopupClick = (familyId: string) => {
        navigate({
            pathname: RouteConstants.stories,
            search: `?${searchParams.toString()}`,
        });
    };
    const handleCardClick = (familyId: any, index: number) => {
        handlePopupClick(familyId);
        handleFocused(index);
    }

    return (
        <div
            className="d-flex justify-content-between align-items-center story-popup rounded m-0 cursor-pointer"
            onClick={() => handleCardClick(story.familyId, index)}
        >
            <div className="padding-right-3 position-relative d-flex align-items-start">
                {!loaded && <div className="d-flex justify-content-center align-items-center image-placeholder position-absolute"></div>}
                <img
                    className="rounded"
                    src={story.image && story.image.length > 0 ? story.image[0] : familySkeleton}
                    alt={story.familyName}
                    onLoad={handleImageLoad}
                />
            </div>
            <div className="p-0 d-flex flex-column justify-content-start">
                <Heading
                    title={story?.familyName}
                    colour={TypographyColor.primary}
                    type={TypographyType.h6}
                    classname='m-0 p-0 text-start'
                />
                <Body
                    type={BodyType.p3}
                    color={BodyColor.secondary}
                    classname='text-start margin-top-bottom-0'
                >
                    {/* <span className="text-black"> */}
                    {`${story.familyDetails.familyMembers} Members`}
                    {/* </span> */}
                </Body>
                <Body
                    type={BodyType.p3}
                    color={BodyColor.secondary}
                    classname='text-start margin-top-bottom-0'
                >
                    <span className="color-black">{getCoreSolutions(story.familyDetails)?.value} </span>
                    annual household spend on {getCoreSolutions(story.familyDetails)?.name}
                </Body>
                {/* <Button
                    theme={ButtonTheme.primary}
                    variant={ButtonVariant.transparent}
                    type='button'
                    onClick={() => navigateToStories()}
                    classname='h-auto text-underline fs-14 button-gray'
                >
                    View all
                    <IoChevronForwardOutline className='fs-14 margin-left-3' />
                </Button> */}
                <Button
                    theme={ButtonTheme.primary}
                    size={ButtonSize.small}
                    variant={ButtonVariant.transparent}
                    onClick={() => handlePopupClick(story.familyId)}
                    classname='h-auto padding-left-0 m-0 p-0 text-underline fs-12 button-gray'
                >
                    Read more
                    <IoChevronForwardOutline className="margin-left-3 fs-12" />
                </Button>
            </div>
        </div>
    )
}